import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const EventsReportApi = createApi({
	reducerPath: "EventReports",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_API_URL}/reports`,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			headers.set("Accept", "application/json");
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		getEventReport: builder.query({
			query: ({
				from: startdate,
				to: enddate,
				selectedids: id,
			}) => `/events?deviceId=${id}&from=${startdate}&to=${enddate}`,
		}),
	
	}),
});

export const {
	useGetEventReportQuery,
} = EventsReportApi;
